<template>
  <form name="scheduler-form" class="SchedulerForm" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12" md="2">
          <BTextFieldDate
            v-model="form.date"
            validate="required"
            :max="form.end_at"
            :skeleton="skeleton"
            :disabled="isView"
            label="Дата"
            placeholder="Дата"
            name="date"
            datetime
            with-buttons
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-model="form.count"
            label="Лимит на дату"
            outlined
            type="number"
            validate="required"
            :skeleton="skeleton"
            name="count"
            datetime
            dense
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-model="form.school_count"
            label="Лимит на ОО"
            outlined
            type="number"
            validate="required"
            :skeleton="skeleton"
            name="count"
            datetime
            dense
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>

import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import { TopicsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

const createDefaultData = () => ({
  // id
  date: '',
  count: void 0,
  school_count: void 0,
  fact_count: void 0,
})

export default {
  name: 'SchedulerForm',
  components: {
    BLayoutExpansion,
    BTextFieldDate,
  },
  extends: BLayoutForm,
  props: {
    editable: Boolean,
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    isLoadingArchived: false,
    isLoadingRedirect: false,
    isLoadingCopy: false,
    counter: 0,
    topics: {},
    procedures: {},
  }),
  async created() {
    this.topics = await new Adapter(new TopicsApi()).getAll()
  },
}
</script>

<style lang="scss" scoped>
.SchedulerForm {
  &__link {
    display: block;
    margin: 0 4px;
    color: $webflow-color-black;
    cursor: pointer;
    text-decoration-line: none;

    &:hover {
      opacity: 0.75;
    }
  }

  &__link-icon {
    pointer-events: none;
  }
}
</style>
